/**
 * Created by Mikhail Menshenin on 18.07.2024
 */

cleverapps.Settings.EditProfileAvailable = function () {
    return !connector.platform.oneOf(connector.OK, connector.VK);
};

SettingsWindow.prototype.createTextWithIcon = function (text, icon) {
    const styles = cleverapps.styles.SettingsWindow.button;

    icon = new cc.Sprite(icon);

    const iconWrapper = new cc.Node();
    iconWrapper.setAnchorPoint(0.5, 0.5);
    iconWrapper.width = styles.icon.width;
    iconWrapper.height = icon.height;

    icon.setAnchorPoint(1, 0);
    icon.x = iconWrapper.width;
    iconWrapper.addChild(icon);

    text = cleverapps.UI.generateOnlyText(Messages.get(text), cleverapps.styles.FONTS.SETTINGS_BUTTON_TEXT);
    text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

    const textWrapper = cleverapps.UI.wrapWithPadding(text);
    textWrapper.width = styles.text.width;
    textWrapper.height = styles.text.height;
    text.x = textWrapper.width / 2;
    text.y = textWrapper.height / 2;
    text.fitTo(textWrapper.width);

    const layout = new cleverapps.Layout([iconWrapper, textWrapper], {
        direction: cleverapps.UI.HORIZONTAL,
        margin: styles.margin,
        padding: styles.padding
    });

    layout.text = text;
    layout.icon = icon;

    return layout;
};